import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const ArrowUpDown = Styled(
	createSvgIcon(
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M9.97325 10.7266H7.89658H6.02658C5.70658 10.7266 5.54658 11.1132 5.77325 11.3399L7.49992 13.0666C7.77658 13.3432 8.22658 13.3432 8.50325 13.0666L9.15992 12.4099L10.2299 11.3399C10.4532 11.1132 10.2932 10.7266 9.97325 10.7266Z'
				fill='currentColor'
			/>
			<path
				d='M10.2269 4.65975L9.15685 3.58975L8.50352 2.93309C8.22685 2.65642 7.77685 2.65642 7.50019 2.93309L5.77352 4.65975C5.54685 4.88642 5.71019 5.27309 6.02685 5.27309H7.89685H9.97352C10.2935 5.27309 10.4535 4.88642 10.2269 4.65975Z'
				fill='currentColor'
			/>
		</svg>,
		'ArrowUpDown'
	)
);

export default ArrowUpDown;
